import React from 'react';

import {
	EXTERNAL_LINK_CCG,
	CHAT_ROOMS_CCG,
	PRODUCT_CODE,
	PRODUCT_NAME,
	ProductEnum,
	PRODUCT_FOOTER_NAME,
	PRODUCT_LINK_IOS_STORE,
	PRODUCT_LINK_ANDROID_STORE,
} from 'presentation/constants';
import {CcgIcon, CcgLogo, CcgAns} from 'presentation/components/Logos';
import {CcgAppIcon} from 'presentation/components/Logos/Ccg/CcgAppIcon';
import {AnsLogoProps, ProductIconProps, ProductLogoProps} from '../types';
import {useThemeStore} from 'presentation/store/useThemeStore';

const theme = useThemeStore.getState().theme;

export const ccgData = {
	productIcon: ({invertColor, color, ...props}: ProductIconProps) => (
		<CcgIcon
			color={color || (invertColor ? theme.brand.primary.white : undefined)}
			{...props}
		/>
	),
	productAppIcon: (props: ProductIconProps) => <CcgAppIcon {...props} />,
	productLogo: ({invertColor, nameColor, ...props}: ProductLogoProps) => (
		<CcgLogo
			nameColor={nameColor || (invertColor ? theme.brand.primary.white : undefined)}
			{...props}
		/>
	),
	ansLogo: (props?: AnsLogoProps) => <CcgAns {...props} />,
	product: ProductEnum.CCG,
	productCode: PRODUCT_CODE.ccg,
	productName: PRODUCT_NAME.ccg,
	footerProductName: PRODUCT_FOOTER_NAME.ccg,
	links: EXTERNAL_LINK_CCG,
	chatRoom: CHAT_ROOMS_CCG,
	iosStoreLink: PRODUCT_LINK_IOS_STORE.ccg,
	androidStoreLink: PRODUCT_LINK_ANDROID_STORE.ccg,
};
